// cases（客户案例）页面私有文案：zh 为完整基准，en 逐 key 对齐
// 客户均为脱敏代号（无真实 logo 阶段，前台用首字母色块占位），P2 再评估后台化
export interface CasesDict {
    meta: { title: string; description: string }
    hero: {
        badge: string
        titleA: string
        titleB: string
        subtitle: string
    }
    wall: {
        titleA: string
        titleB: string
        desc: string
        clients: { name: string; tag: string }[]
    }
    testimonials: {
        titleA: string
        titleB: string
        items: { quote: string; author: string; role: string }[]
    }
    stats: { value: string; label: string }[]
    cta: {
        title: string
        button: string
    }
}

export const casesDict: { zh: CasesDict; en: CasesDict } = {
    zh: {
        meta: {
            title: '客户案例 - YYGame',
            description: '全球社交与泛娱乐应用都在用 YYGame 互动游戏内容：3 天快速接入、7×24 技术服务、全球节点覆盖，覆盖语音社交、直播互动、游戏平台等多种场景。',
        },
        hero: {
            badge: 'Customer Stories',
            titleA: '全球应用都在用，',
            titleB: '与客户一起增长',
            subtitle: '众多应用的共同选择，用游戏化撬动活跃与营收',
        },
        wall: {
            titleA: '他们都在使用 ',
            titleB: 'YYGame',
            desc: '以下为部分合作客户（脱敏展示），覆盖语音社交、直播互动、游戏平台等多个赛道。',
            clients: [
                { name: 'S***Live', tag: '语音社交' },
                { name: 'C***Wave', tag: '陌生人社交' },
                { name: 'P***Go', tag: '游戏社交' },
                { name: 'S***Up', tag: '语音房' },
                { name: 'L***Fun', tag: '直播互动' },
                { name: 'G***Box', tag: '游戏平台' },
                { name: 'M***Chat', tag: '元宇宙社交' },
                { name: 'V***Hub', tag: '兴趣社区' },
                { name: 'P***Link', tag: '渠道分发' },
                { name: 'F***Zone', tag: '泛娱乐' },
            ],
        },
        testimonials: {
            titleA: '听听客户的 ',
            titleB: '真实反馈',
            items: [
                {
                    quote: '接入只用了一个下午，当晚直播间同时在线人数就创了新高。互动玩法让我们的付费转化提升了三成。',
                    author: '某头部语音社交平台',
                    role: '产品负责人',
                },
                {
                    quote: '游戏内容更新快、质量稳，运营方案也很落地。门票房玩法上线一个月，房间流水翻了一倍。',
                    author: '某直播互动应用',
                    role: '运营总监',
                },
                {
                    quote: '多语言和全球节点开箱即用，我们几乎零成本就把游戏玩法铺到了东南亚和中东市场。',
                    author: '某出海社交应用',
                    role: '技术负责人',
                },
            ],
        },
        stats: [
            { value: '3 天', label: '平均接入时长' },
            { value: '7×24', label: '技术服务响应' },
            { value: '全球', label: '加速节点覆盖' },
        ],
        cta: {
            title: '想和它们一样，让业务更好玩？',
            button: '联系商务',
        },
    },
    en: {
        meta: {
            title: 'Customer Stories - YYGame',
            description: 'Social and entertainment apps worldwide run on YYGame interactive games: 3-day integration, 7×24 support and global edge coverage across voice social, live interaction and game platforms.',
        },
        hero: {
            badge: 'Customer Stories',
            titleA: 'Trusted by apps worldwide, ',
            titleB: 'growing together',
            subtitle: 'Trusted by apps worldwide — gameplay that drives growth',
        },
        wall: {
            titleA: 'They all build on ',
            titleB: 'YYGame',
            desc: 'A selection of our partners (anonymized), spanning voice social, live interaction, game platforms and more.',
            clients: [
                { name: 'S***Live', tag: 'Voice Social' },
                { name: 'C***Wave', tag: 'Chat & Dating' },
                { name: 'P***Go', tag: 'Party Games' },
                { name: 'S***Up', tag: 'Voice Rooms' },
                { name: 'L***Fun', tag: 'Live Interactive' },
                { name: 'G***Box', tag: 'Game Platform' },
                { name: 'M***Chat', tag: 'Metaverse Social' },
                { name: 'V***Hub', tag: 'Interest Community' },
                { name: 'P***Link', tag: 'Distribution' },
                { name: 'F***Zone', tag: 'Entertainment' },
            ],
        },
        testimonials: {
            titleA: 'What our ',
            titleB: 'clients say',
            items: [
                {
                    quote: 'Integration took a single afternoon, and that night our live room hit a new concurrent-user peak. Interactive playstyles lifted paid conversion by 30%.',
                    author: 'A leading voice social platform',
                    role: 'Head of Product',
                },
                {
                    quote: 'Fast content updates, reliable quality and practical operation playbooks. One month after launching ticket rooms, our room revenue doubled.',
                    author: 'A live interaction app',
                    role: 'Operations Director',
                },
                {
                    quote: 'Multi-language support and global edge nodes worked out of the box — we rolled out gameplay across Southeast Asia and the Middle East at almost zero cost.',
                    author: 'A global social app',
                    role: 'CTO',
                },
            ],
        },
        stats: [
            { value: '3 Days', label: 'Avg. Integration Time' },
            { value: '7×24', label: 'Technical Support' },
            { value: 'Global', label: 'Edge Node Coverage' },
        ],
        cta: {
            title: 'Want to make your business more fun, just like them?',
            button: 'Contact Sales',
        },
    },
}
